import { render, staticRenderFns } from "./ApproverMaster.vue?vue&type=template&id=77fe308e&scoped=true"
import script from "./ApproverMaster.vue?vue&type=script&lang=js"
export * from "./ApproverMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fe308e",
  null
  
)

export default component.exports